import { useApolloClient as useClient } from '@apollo/client/react'

export const useApolloClient = () => {
  const client = useClient()

  return { client }
}
